import React from 'react';
import PropTypes from 'prop-types';
import styles from './ImportFileList.module.scss';
import filesize from 'filesize';

export default function ImportFileList(props) {
  /*
    #TODO: I don't like importing an entire package
    just for the filesize function. Let's steal that code.
    -- TJC - February 01, 2020
  */

  const renderFiles = props.files.map((file, i) => {
    return <div className={styles.fileListItem} key={i}>
      <p className={styles.fileListItemName}>{ file.name }</p>
      <p className={styles.fileListItemSize}>{ filesize(file.size) }</p>
      <p className={styles.fileListItemSize}>{ file.contents }</p>
    </div>;
  });

  return (
    <>
      <h2 className={styles.fileListHeader}>Selected File</h2>
      <ul className={styles.fileList}>
        { renderFiles }
      </ul>
    </>
  );
}

ImportFileList.propTypes = {
  files: PropTypes.array
};
